<template>
  <div v-if="useRecoveryCode">
    <label for="recoveryCode" class="block text-sm font-medium text-gray-700"> Recovery Code </label>
    <div class="mt-1">
      <input :value="recoveryCode" @input="$emit('update:recoveryCode', $event)" id="recoveryCode" name="recoveryCode"
             required="" placeholder="Provided when you enabled 2FA"
             class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 shadow-sm placeholder-gray-400 -500 focus:ring-primary-500 focus:border-primary-600 focus:outline-none sm:text-sm"/>
    </div>
  </div>
  <div v-else>
    <label for="code" class="block text-sm font-medium text-gray-700"> Code </label>
    <div class="mt-3">
      <FormVerificationCodeInput :model-value="code" @update:modelValue="$emit('update:code', $event)" name="code"
                                 id="code" required/>
    </div>
  </div>

  <button type="button" @click="toggleUseRecoveryCode"
          class="text-sm font-medium text-primary-600 hover:text-primary-700 hover:underline">
    {{ useRecoveryCode ? "Use your authenticator app" : "Use a recovery code" }} instead
  </button>
</template>

<script setup>
import FormVerificationCodeInput from "./FormVerificationCodeInput.vue";
import {ref} from "vue";

const emits = defineEmits(["update:code", "update:recoveryCode"]);
defineProps({
  code: String,
  recoveryCode: String,
});

const useRecoveryCode = ref(false);

const toggleUseRecoveryCode = () => {
  emits("update:code", "");
  emits("update:recoveryCode", "");
  useRecoveryCode.value = !useRecoveryCode.value;
};
</script>
